<svg xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"  
	{...$$restProps}
>
  <path d="M5.29292 6.70714L16.8049 18.2181C17.1955 18.6086 17.8286 18.6086 18.2191 18.2181C18.6096 17.8275 18.6096 17.1944 18.2191 16.8039L6.70708 5.29286C6.31653 4.90236 5.68337 4.90238 5.29286 5.29292C4.90236 5.68347 4.90238 6.31663 5.29292 6.70714Z" />
  <path d="M16.7211 5.29773L5.28809 16.8877C4.90024 17.2809 4.90455 17.9141 5.29773 18.3019C5.69091 18.6898 6.32406 18.6854 6.71191 18.2923L18.1449 6.70227C18.5328 6.30909 18.5284 5.67594 18.1353 5.28809C17.7421 4.90024 17.1089 4.90455 16.7211 5.29773Z" />
</svg>  